/* istanbul ignore file */
import * as Integrations from "@sentry/integrations"
import * as SentryBrowser from "@sentry/browser"
import * as SentryVue from "@sentry/vue"
import { meta } from "@/support"

export const sentry = {
  mount(app = null) {
    const Sentry = app ? SentryVue : SentryBrowser

    Sentry.init({
      app,
      dsn: meta("sentry:dsn"),
      environment: meta("sentry:environment"),
      release: meta("sentry:release"),
      integrations: [
        new Integrations.CaptureConsole({ levels: ["error"] }),
      ],
    })

    if (app) {
      app.mixin(Sentry.createTracingMixins({ trackComponents: true }))

      Sentry.attachErrorHandler(app, { logErrors: true })
    }
  },
}
